import { render } from "./InformationPost.vue?vue&type=template&id=4995dfe3"
import script from "./InformationPost.vue?vue&type=script&lang=js"
export * from "./InformationPost.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__